import { ERole, User } from './user.model';

export class Client extends User {   

    constructor(uid:string) {
        super(uid);
        this.role = ERole.Client;
    }     

}